


































import VueOptions from '@utils/VueOptions'

settings =
  name: 'SendRecapTutorialStep'

export default VueOptions.vue settings
